import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	createSchedule: {
		id: 'eoc-schedule.ui.section.create-schedule.create-schedule',
		defaultMessage: 'Create schedule',
		description: 'Create a new schedule title.',
	},
	scheduleName: {
		id: 'eoc-schedule.ui.section.create-schedule.schedule-name',
		defaultMessage: 'Schedule name',
		description: 'Text field label for schedule name.',
	},
	description: {
		id: 'eoc-schedule.ui.section.create-schedule.description',
		defaultMessage: 'Description',
		description: 'Text field label for schedule description.',
	},
	create: {
		id: 'eoc-schedule.ui.section.create-schedule.create',
		defaultMessage: 'Create',
		description: 'A create button for create schedule.',
	},
	timezone: {
		id: 'eoc-schedule.ui.section.create-schedule.timezone',
		defaultMessage: 'Timezone',
		description: 'Text field label for schedule timezone.',
	},
	copyOf: {
		id: 'eoc-schedule.ui.section.create-schedule.copy-of',
		defaultMessage: 'Copy of {scheduleName}',
		description: 'Automatically generated cloned schedule name. Ex. Copy of Paid Schedule',
	},
});
